import React from "react";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";

let genericIndex = 0;

export const ChipsReadonly = ({ data, onChange, title }) => (
  <FormControl style={{ width: "100%" }} disabled={true} variant="outlined">
    <InputLabel id={"chips-label"}>{title}</InputLabel>
    <Select
      multiple
      value={data}
      variant="outlined"
      id="chips"
      onChange={event => onChange(event.target.value)}
      label={title}
      renderValue={selected => (
        <div style={{ whiteSpace: "normal" }}>
          {data.map(value => {
            return (
              <Chip
                key={genericIndex++}
                label={value}
                style={{ margin: "2px 2px 0 0" }}
                color="primary"
              />
            );
          })}
        </div>
      )}
      MenuProps={MenuProps}
    >
    </Select>
  </FormControl>
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
